import React from 'react';
import { Button, Text, Title } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useCreateAndNavToTest } from '~/hooks/api/useCreateAndNavToTest';

export default function NoTestsMessage() {
  const createTestHandler = useCreateAndNavToTest({});

  return (
    <div className="flex flex-col items-start gap-6 py-12">
      <div className="flex flex-col items-start gap-1">
        <Title order={4}>You don&apos;t have any available tests.</Title>
        <Text>Create a test to get started!</Text>
      </div>
      <Button
        leftSection={<IconPlus size={16} />}
        onClick={() => createTestHandler()}
      >
        Create Test
      </Button>
    </div>
  );
}
